<div class="card">
    <div class="cardTitle">
        <i class="fas fa-info-circle fa-2x"></i>
    </div>

    <div class="cardContent">
        <label for="version" class="labelTop">{{ 'listing.version.selectVersion' | translate }}</label>
        <app-typeahead-select
            id="version"
            placeholder="listing.version.placeholder"
            labelKey="label"
            idKey="version"
            [optionsList]="versions"
            [formControl]="formControl"
        />
    </div>

    <div class="cardFooter">
        <footer class="buttonArea stickyBottom centeredButtons">
            <button class="button primary" (click)="compareWithVersion()">
                {{ 'generalKeywords.confirm' | translate }}
            </button>
            <button type="button" class="button" (click)="closeModal()">{{ 'generalKeywords.cancel' | translate }}</button>
        </footer>
    </div>
</div>
